import { useSingleSelectField } from '../../../lib/hooks/useSingleSelectField';
import { SingleSelectContentCombinedProps } from './types';
import { REFERENCE_FIELDS } from '../../../lib/constants';

const usePresenter = (props: SingleSelectContentCombinedProps): SingleSelectContentCombinedProps => {
  const singleSelectProps = useSingleSelectField(props);

  const { handleBlur: handleCellBlur, dataType } = props;

  const handleBlur = (event?: React.FocusEvent<HTMLDivElement | HTMLTextAreaElement>) => {
    // to handle focusing on children of cell e.g. TagList in the reference field dropdown
    if (event && !event.currentTarget.contains(event.relatedTarget)) {
      handleCellBlur?.();
    }
  };

  return {
    ...props,
    ...singleSelectProps,
    handleBlur: dataType && REFERENCE_FIELDS.includes(dataType) ? handleBlur : handleCellBlur,
  };
};

export default usePresenter;
